"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FormRenderer_1 = __importDefault(require("../FormRenderer"));
const FormContexts_1 = require("../Contexts/FormContexts");
const ConditionalOptimizer_1 = __importDefault(require("../wrappers/ConditionalOptimizer"));
const FieldRender_1 = __importDefault(require("../wrappers/FieldRender"));
const RepeatableRender_1 = __importDefault(require("../wrappers/RepeatableRender"));
const ComputedOptimizer_1 = __importDefault(require("../wrappers/ComputedOptimizer"));
const GroupComponent = props => {
    const { controlDefinition, controlPath } = props;
    const { controlMap } = FormContexts_1.useControlProvider();
    const renderFn = react_1.useCallback((props, repeatableProps) => {
        return (react_1.default.createElement(controlMap.GroupWrapper, { functionDefinitions: props.functionDefinitions, controlDefinition: controlDefinition, isOriginal: repeatableProps.isOriginal, 
            //TODO: this doesn't seem correct
            itemCount: controlDefinition.template.order.length, onAddClick: repeatableProps.onAddClick, onRemoveClick: repeatableProps.onRemoveClick, readOnly: !!props.readOnly, repeatable: repeatableProps.repeatable, repeatCount: repeatableProps.repeatCount, controlPath: controlPath, index: repeatableProps.index },
            react_1.default.createElement(FormRenderer_1.default, { childMode: true, template: controlDefinition.template, controlPathPrefix: repeatableProps.repeatable ? repeatableProps.controlPath : controlPath })));
    }, [controlDefinition, controlMap, controlPath]);
    const renderControl = react_1.useCallback((repeatableProps) => {
        return (react_1.default.createElement(FieldRender_1.default, { controlPath: controlPath, controlDefinition: controlDefinition, key: repeatableProps.key, render: props => renderFn(props, repeatableProps) }));
    }, [renderFn, controlDefinition, controlPath]);
    return (react_1.default.createElement(ConditionalOptimizer_1.default, { conditionalMap: controlDefinition.conditionalMap },
        react_1.default.createElement(ComputedOptimizer_1.default, { controlDefinition: controlDefinition, controlPath: controlPath },
            react_1.default.createElement(RepeatableRender_1.default, { controlPath: controlPath, controlDefinition: controlDefinition, renderControl: renderControl, defaultValue: {} }))));
};
exports.default = react_1.default.memo(GroupComponent);
